import { takeLatest, call, put, all } from 'redux-saga/effects'

import { BASE_PATH, LANG } from '../../../containers/App/constants'
import { request } from '../../../utils/request'
import { loadSliderSuccess, loadSliderError, loadCollectHomeSuccess, loadCollectHomeError } from './actions'
import { LOAD_SLIDER, LOAD_COLLECT_HOME } from './constants'
import { slidesSchema } from './validation/sliderSchema'

export function* getSlider(data) {
  const url = `${BASE_PATH}/content/${LANG}/slider/${data.name}`
  try {
    const response = yield call(request, url, {
      headers: {
        accept: 'application/json',
      },
    })

    const slider = slidesSchema.validateSync(response.data)

    yield put(loadSliderSuccess(slider, response.flashMessages))
  } catch (error) {
    yield put(loadSliderError(error))
  }
}

export function* watchSliderLoad() {
  yield takeLatest(LOAD_SLIDER, getSlider)
}

function* getCollectHome() {
  const url = `${BASE_PATH}/content/${LANG}/collect-home`
  try {
    const response = yield call(request, url, {
      headers: {
        accept: 'application/json',
      },
    })

    yield put(loadCollectHomeSuccess(response.data))
  } catch (error) {
    yield put(loadCollectHomeError(error))
  }
}

function* watchCollectHomeLoad() {
  yield takeLatest(LOAD_COLLECT_HOME, getCollectHome)
}

export default function* rootSagas() {
  yield all([watchSliderLoad(), watchCollectHomeLoad()])
}
